import { TransactionDto } from "@api-types/games";

export class RoundTransactionData {
	roundId: string;
	transactions: TransactionDto[];
}
